import React, { useContext } from "react";
import { ErrorMessage, Field } from "formik";
import { Link } from "react-router-dom";

import { SettingsContext } from '../../contexts';

const TermsCheckbox = () => {
    const { isRetailCircle } = useContext(SettingsContext);
    const termsUrl = isRetailCircle ? 'https://www.retail-circle.io/terms-of-service' : '/terms';
    const privacyUrl = isRetailCircle ? 'https://www.retail-circle.io/privacy-policy' : '/privacy';

    return (
        <div className="terms" style={{marginTop: '40px'}}>
            <label>
                <Field type="checkbox" name="accept_terms" />
                By creating an account you agree with the&nbsp;
                {isRetailCircle ? (
                  <>
                    <a href={termsUrl} target="_blank">terms of use</a>
                    &nbsp;and our&nbsp;
                    <a href={privacyUrl} target="_blank">privacy policy</a>
                  </>
                ) : (
                  <>
                    <Link to={termsUrl} target="_blank">terms of use</Link>
                    &nbsp;and our&nbsp;
                    <Link to={privacyUrl} target="_blank">privacy policy</Link>
                  </>
                )}

                <ErrorMessage
                    name="accept_terms"
                    style={{margin: "10px 0 0 29px"}}
                    component="div"
                    className="error"
                />
            </label>
        </div>
    )
};

export default TermsCheckbox;
